import { weekDaysEn } from "../../utils";
import { WeekTypeHeader } from "../StyledComponents";
import Day from "./Day";
import { WeekType } from "./modal";
import { useSelector } from "../../../store/store";
import { isOddWeekUsed } from "../../../store/data";
import { useTranslation } from "react-i18next";

interface Props {
    weekType: WeekType;
}

const RegularWeek = ({ weekType }: Props) => {
    const oddWeekUsed = useSelector(isOddWeekUsed);
    const { t } = useTranslation();
    return (
        <>
            {oddWeekUsed && (
                <WeekTypeHeader weekType={weekType}>
                {weekType === "odd" ? t('odd_week') : t('even_week')}
                </WeekTypeHeader>
            )}
            {weekDaysEn.map((name, i) => (
                <Day
                    key={t(name)}
                    day={{ isRegular: true, index: i, name, weekType }}
                />
            ))}
        </>
    );
};

export default RegularWeek;
